import EventEmitter from './EventEmitter';

class Draggable extends EventEmitter {
    constructor(domElement, options) {
        super();

        this.domElement = domElement;
        this.parentDomElement = options.parent || null;
        this.dragAnchorElement = options.dragAnchor || this.domElement;
        this.movement = options.movement || 'any';
        this.unit = !!options.parent ? (options.unit || 'px') : 'px';

        this.cloneDraggable = options.cloneDraggable || false;
        this.scanNearestElement = options.scanNearestElement || false;
        this.scanNearestElementSelector = options.scanNearestElementSelector || '*';

        this.rect = {x: 0, y: 0, left: 0, right: 0, top: 0, bottom: 0, width: 0, height: 0};
        this.parentRect = {x: 0, y: 0, left: 0, right: 0, top: 0, bottom: 0, width: 0, height: 0};

        this.draggingDomElement = null;
        this.dragCorrectionX = 0;
        this.dragCorrectionY = 0;

        this.dragAnchorElement.classList.add('draggable');

        this.bindEvents();
    }

    bindEvents() {
        this.dragAnchorElement.addEventListener('mousedown', this.onDomElementMouseDown.bind(this));
    }

    onDomElementMouseDown(e) {
        if (e.target.tagName === 'A' ||
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'BUTTON' ||
            e.target.tagName === 'TEXTAREA') {
            return;
        }

        e.preventDefault();

        this.emit({
            type: 'dragstart',
            element: this.domElement,
        });

        this.rect = this.domElement.getBoundingClientRect();
        this.draggingDomElement = this.cloneDraggable ? this.domElement.cloneNode(true) : this.domElement;
        this.dragCorrectionX = e.clientX - this.rect.x;
        this.dragCorrectionY = e.clientY - this.rect.y;

        if (this.cloneDraggable === true) {
            this.draggingDomElement.style.position = 'fixed';
            this.draggingDomElement.style.width = this.rect.width + 'px';
            this.draggingDomElement.style.height = this.rect.height + 'px';
            this.draggingDomElement.style.left = this.rect.left + 'px';
            this.draggingDomElement.style.top = this.rect.top + 'px';

            this.draggingDomElement.classList.add('dragging-clone');

            document.body.appendChild(this.draggingDomElement);
        }

        document.body.classList.add('dragging');

        if (!!this.parentDomElement) {
            this.parentRect = this.parentDomElement.getBoundingClientRect();
        }

        this.onDocumentMouseMove(e);

        this.documentMouseMoveEvent = this.onDocumentMouseMove.bind(this);
        this.documentMouseUpEvent = this.onDocumentMouseUp.bind(this);

        document.addEventListener('mousemove', this.documentMouseMoveEvent);
        document.addEventListener('mouseup', this.documentMouseUpEvent);
    }

    onDocumentMouseMove(e) {
        let newX = e.clientX - this.dragCorrectionX;
        let newY = e.clientY - this.dragCorrectionY;

        if (!!this.parentDomElement) {
            if (this.unit === '%') {
                newX = Math.min(Math.max(0, (100 / (this.parentRect.right - this.parentRect.left)) * newX - this.parentRect.left), 100);
                newY = Math.min(Math.max(0, (100 / (this.parentRect.bottom - this.parentRect.top)) * newY - this.parentRect.top), 100);
            } else {
                if (newX < this.parentRect.left) {
                    newX = this.parentRect.left;
                } else if (newX > (this.parentRect.right - this.rect.width)) {
                    newX = this.parentRect.right - this.rect.width;
                }

                if (newY < this.parentRect.top) {
                    newY = this.parentRect.top;
                } else if (newY > (this.parentRect.bottom - this.rect.height)) {
                    newY = this.parentRect.bottom - this.rect.height;
                }
            }
        }

        if (this.movement === 'any' || this.movement === 'horizontal') {
            this.draggingDomElement.style.left = newX + this.unit;
        }

        if (this.movement === 'any' || this.movement === 'vertical') {
            this.draggingDomElement.style.top = newY + this.unit;
        }

        let nearestElement = null;
        if (this.scanNearestElement === true) {
            const foundElement = document.elementFromPoint(e.clientX, e.clientY);
            nearestElement = foundElement.closest(this.scanNearestElementSelector);
        }

        this.emit({
            type: 'drag',
            mouseX: e.clientX,
            mouseY: e.clientY,
            elementX: newX,
            elementY: newY,
            element: this.domElement,
            nearestElement,
        });
    }

    onDocumentMouseUp(e) {
        e.preventDefault();

        this.documentMouseMoveEvent(e);
        document.body.classList.remove('dragging');

        if (this.cloneDraggable === true) {
            this.draggingDomElement.parentNode.removeChild(this.draggingDomElement);
        }

        document.removeEventListener('mousemove', this.documentMouseMoveEvent);
        document.removeEventListener('mouseup', this.documentMouseUpEvent);

        this.emit({
            type: 'dragend',
            element: this.domElement,
        });
    }
}

export default Draggable;
